import PixagriScopes from '../../core/models/PixagriScopes';
import { BaseOrchestratorApiService } from '../../core/services/apiServices/BaseOrchestratorApiService';
import ExecuteFieldProcessResponse from '../models/ExecuteFieldProcessResponse';
import ExecuteProcessFieldRequest from '../models/ExecuteProcessFieldRequest';
import FieldProcessEngineJob from '../models/FieldProcessEngineJob';
import ProcessEngineType from '../models/ProcessEngineType';
import ProcessingType from '../models/ProcessingType';

export class PixagriProcessingOrchestratorApiService extends BaseOrchestratorApiService {
    PROCESS_ENGINES_ENDPOINT = '/processes';
    CAMPAIGN_YEAR_QUERY = 'campaign_year';
    PROCESS_PARAM_KEY = `processRef`;
    PROCESS_PARAM = `:${this.PROCESS_PARAM_KEY}`;
    JOB_PARAM_KEY = 'jobId';
    JOB_PARAM = `:${this.JOB_PARAM_KEY}`;

    CLOUDVI_SCOPE = 'cloudvi';
    SUCCESS_ENDPOINT = 'success'
    VISIOCROP_SUCCESS_ENDPOINT = `${ProcessingType.VISIOCROP}/${this.SUCCESS_ENDPOINT}`
    ERROR_ENDPOINT = 'error'
    VISIOCROP_ERROR_ENDPOINT = `${ProcessingType.VISIOCROP}/${this.ERROR_ENDPOINT}`

    getCloudViVisioCropSuccessCallbackUrl() {
        return `${this.getBaseUrl()}/${this.CLOUDVI_SCOPE}/${this.VISIOCROP_SUCCESS_ENDPOINT}`;
    }

    getCloudViVisiocropErrorCallbackUrl() {
        return `${this.getBaseUrl()}/${this.CLOUDVI_SCOPE}/${this.VISIOCROP_ERROR_ENDPOINT}`;
    }

    getTriggerCloudViUrl() {
        return `${this.getBaseUrl()}/cloudvi/visiocrop/batchFields`;
    }
    getProcessingPartialPath() {
        return `/${this.PROCESS_PARAM}`;
    }

    getExecuteProcessingPartialPath() {
        return `${this.getProcessingPartialPath()}/execution`;
    }

    getProcessingFieldJobsPartialPath() {
        return `${this.getProcessingPartialPath()}/processing-jobs/${this.JOB_PARAM
            }`;
    }
    getHandleProcessJobSuccessPartialPath() {
        return `${this.getProcessingPartialPath()}/job-success-callback`;
    }

    getHandleProcessJobFailurePartialPath() {
        return `${this.getProcessingPartialPath()}/job-failure-callback`;
    }

    getHandleProcessJobDeadletterPartialPath() {
        return `${this.getProcessingPartialPath()}/job-deadletter-callback`;
    }

    executeProcessJobUrl(processRef: ProcessEngineType) {
        return `${this.getBaseUrl()}/${PixagriScopes.PROCESSINGS
            }${this.getExecuteProcessingPartialPath().replace(
                this.PROCESS_PARAM,
                processRef,
            )}`;
    }
    getFieldProcessEngineJobsUrl(processRef: ProcessEngineType) {
        return `${this.getBaseUrl()}/${PixagriScopes.PROCESSINGS
            }${this.getProcessingPartialPath().replace(
                this.PROCESS_PARAM,
                processRef,
            )}`;
    }

    async executeProcessField(
        token: string,
        processRef: ProcessEngineType,
        payload: ExecuteProcessFieldRequest,
    ): Promise<ExecuteFieldProcessResponse> {
        const url = this.executeProcessJobUrl(processRef)
        const res = await this.sendRequest<ExecuteFieldProcessResponse>(token, url, 'POST', payload);
        if (res.error) {
            throw res.error_message;
        }
        return res.response;
    }
    async getFieldProcessEngineJobs(
        token: string,
        processRef: ProcessEngineType,
    ): Promise<FieldProcessEngineJob[]> {
        const url = this.getFieldProcessEngineJobsUrl(processRef);
        const res = await this.sendRequest<FieldProcessEngineJob[]>(
            token,
            url,
            'GET',
        );
        if (res.error) {
            throw res.error_message;
        }
        return res.response;
    }
}
export const pixagriProcessingOrchestratorApiService =
    new PixagriProcessingOrchestratorApiService();
